// Pick the org the app opens on. A caller can belong to MORE than one personal org: their own,
// and one another user invited them into. A personal org's id equals its owner's user id, so the
// caller's own personal org is the one whose id is the caller's id. `personal` alone does not
// say whose it is, and the first personal row in the list can be somebody else's.

type Org = { id: string; personal: boolean }

// The caller's own personal org, else the first org, else nothing.
export function ownPersonalOrg<T extends Org>(orgs: T[], userId: string): T | undefined {
  return orgs.find(o => o.personal && o.id === userId) ?? orgs[0]
}

// The org to open: the caller's last selection if they are still a member, else their own
// personal org.
export function defaultOrg<T extends Org>(orgs: T[], userId: string, stored: string | null): T | undefined {
  return orgs.find(o => o.id === stored) ?? ownPersonalOrg(orgs, userId)
}

// The last selection is kept PER USER. One browser can sign in as two users, and the selection
// one of them made must not open the other on an org they share.
export function activeOrgKey(userId: string): string {
  return `nobgp.activeOrgId.${userId}`
}
